module.exports = __webpack_public_path__ + "static/media/bill2.f802fffc.png";